import { Component, OnInit } from '@angular/core';
import { AdminService, UpdateCustomerProps } from 'app/services/admin.service';
import { AgencyCounty, AgencyInfoService } from 'app/services/agency-info.service';
import { GivCustomerInitInfo } from 'app/services/agency-info.service';
import { UserService } from 'app/services/user.service';
import { EditService } from 'app/services/edit.service';
import { ToastrService } from 'ngx-toastr';

interface Info extends GivCustomerInitInfo {
	shortName?: string;
	longName?: string;
}
@Component({
  selector: 'app-config-agency-profile',
  templateUrl: './config-agency-profile.component.html',
  styleUrls: ['./config-agency-profile.component.css', '../config-sub-agencies/add-sub-agency-modal/add-sub-agency-modal.component.css']
})
export class ConfigAgencyProfileComponent implements OnInit {

	isApplying: boolean;
	hasChanged: boolean;
	
	info: Info = {
		nguidPattern: {}
	};
	private originalInfo: Info;

	givBdryCateList: {
		prop: string;
		name: string;
	}[] = [];
	countyList: AgencyCounty[] = [];

	constructor(
		private toastr: ToastrService,
		private agencyInfoService: AgencyInfoService,
		private adminService: AdminService,
		private editService: EditService,
		private userService: UserService
	) { }

	onChange() {
		this.hasChanged = !!Object.keys(this.originalInfo).find(k => {
			return this.editService.hasValueChanged(this.info[k], this.originalInfo[k]);
			// if (this.info[k] !== this.originalInfo[k]) {
			// 	if (this.info[k] && this.originalInfo[k] && typeof (this.info[k]) === 'object') {
			// 		return JSON.stringify(this.info[k]) !== JSON.stringify(this.originalInfo[k]);
			// 	}
			// }
		});
	}
	onSelectCounty() {
		if (this.info.county) {
			this.info.bdryName = this.info.county.name;
			// this.info.centroidLatlong = this.info.county.centroidStr;
		} else {
			this.info.bdryName = '';
			// this.info.centroidLatlong = null;
		}
		this.hasChanged = true;
	}
	onChangeNeighborCounty() {
		this.hasChanged = true;
	}
	onPatternChange(e) {
		this.info.nguidPattern = e;
		this.hasChanged = true;
	}

	async apply() {
		this.isApplying = true;
		try {
			const props: UpdateCustomerProps = {};
			// Get all keys from info and original info (they may not have all keys in each)
			const keys = Object.keys(this.originalInfo).concat(Object.keys(this.info));
			const uniqueKeys = keys.filter((k, idx) => keys.indexOf(k) === idx);
			// Filter changed props
			uniqueKeys.filter(k => {
				if (k === 'county') {
					if (this.info.county && this.originalInfo.county) {
						return this.info.county.name !== this.originalInfo.county.name;
					} else {
						return !(!this.info.county && !this.originalInfo.county);
					}
				} else {
					return this.editService.hasValueChanged(this.info[k], this.originalInfo[k]);
				}
			}).forEach(k => {
				switch (k) {
					case 'shortName':
						props.customerShortName = this.info.shortName;
						break;
					case 'longName':
						props.customerLongName = this.info.longName;
						break;
					case 'bdryName':
						props.givBoundaryName = this.info.bdryName;
						break;
					case 'bdryCate':
						props.givBoundaryCat = this.info.bdryCate;
						break;
					case 'county':
						props.customerCounties = this.info.county ? [this.info.county.name] : [] // this.countyList.filter(c => c.isNeighbor).map(c => c.name)
						props.customerCentroid = this.info.county.centroidStr;
						break;
					case 'discrepancyAgencyId':
						props.discripAgId = this.info.discrepancyAgencyId;
						break;
					case 'nguidPattern':
						props.customerNguidPattern = this.info.nguidPattern.layerType ? 2 : 1
						break;
				}
			})
			await this.adminService.updateCustomer(props, this.userService.customerInfo.id);
			this.hasChanged = false;
			this.toastr.success('Successfully updated.')
			await this.userService.getCustomerInfo(null, true);
			this.setInfo();
		} catch (err) {
			this.toastr.error(err.message);
			console.log(err);
		}
		this.isApplying = false;
	}

	private setInfo() {
		this.info = {
			shortName: this.userService.customerInfo.nameShort,
			longName: this.userService.customerInfo.nameLong,
			bdryName: this.userService.customerInfo.bdryName,
			bdryCate: this.userService.customerInfo.bdryCate,
			county: this.countyList.find(c => c.centroidStr === this.userService.customerInfo.cusCentroid),
			// centroidLatlong: '',
			discrepancyAgencyId: this.userService.customerInfo.discrepancyId,
			nguidPattern: JSON.parse(JSON.stringify(this.userService.customerInfo.nguidPattern))
			// {
			// 	layerType: this.agencyInfoService.getIsLayerTypeFromNguidPattern(this.userService.customerInfo.nguidPattern)
			// }
		}
		this.originalInfo = JSON.parse(JSON.stringify(this.info));
		// this.userService.customerInfo.cusCounties.forEach(c => {
		// 	const county = this.countyList.find(i => i.name === c);
		// 	if (county) {
		// 		county.isNeighbor = true;
		// 	}
		// })
	}
	async ngOnInit() {
		this.countyList = await this.agencyInfoService.getCounties();
		this.givBdryCateList = this.agencyInfoService.givBdryCateList;

		this.setInfo();

	}

}
